import React, { useState, useEffect } from 'react';
import { Card, Form, Select, InputNumber, Button, message } from 'antd';
import { Api_VariavelGlobal } from '../global';

const { Option } = Select;

const StoreMoviments = () => {
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  // Estado para pegar o usuário logado do localStorage
  const [userId, setUserId] = useState(localStorage.getItem('userId') || '');

  useEffect(() => {
    fetchProdutos();
  }, []);

  const fetchProdutos = async () => {
    try {
      const res = await fetch(`${Api_VariavelGlobal}/api/produtos`);
      const data = await res.json();
      setProdutos(data);
    } catch (error) {
      message.error('Erro ao carregar produtos');
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await fetch(`${Api_VariavelGlobal}/api/movimentacoes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ID_PRODUTO: values.ID_PRODUTO,
          TIPO: values.TIPO,
          QUANTIDADE: values.QUANTIDADE,
          MOTIVO: values.MOTIVO || '',
          USUARIO: userId, // Aqui usa o userId do estado
        }),
      });

      if (!res.ok) throw new Error('Erro no servidor');

      message.success('Movimentação registrada com sucesso!');

      form.resetFields();

      await fetchProdutos();

    } catch (error) {
      message.error('Erro ao registrar movimentação.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div title="Movimentação de Estoque" style={{ marginRight: 10 }}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Produto"
          name="ID_PRODUTO"
          rules={[{ required: true, message: 'Selecione um produto' }]}
        >
          <Select placeholder="Selecione o produto" showSearch optionFilterProp="children" filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }>
            {produtos.map((p) => (
              <Option key={p.ID_PRODUTO} value={p.ID_PRODUTO}>
                {p.PRODUTO}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Tipo de Movimentação"
          name="TIPO"
          rules={[{ required: true, message: 'Selecione o tipo' }]}
        >
          <Select placeholder="Selecione o tipo">
            <Option value="ENTRADA">Entrada</Option>
            <Option value="SAIDA">Saída</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Quantidade"
          name="QUANTIDADE"
          rules={[
            { required: true, message: 'Informe a quantidade' },
            { type: 'number', min: 1, message: 'Quantidade mínima é 1' },
          ]}
        >
          <InputNumber min={1} style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label="Motivo" name="MOTIVO">
          <Select placeholder="Selecione um motivo (opcional)">
            <Option value="COMPRA">Compra</Option>
            <Option value="VENDA">Venda</Option>
            <Option value="AJUSTE">Ajuste</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Registrar Movimentação
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default StoreMoviments;
